import { MisconfigurationsAppWebComponent } from './component/MisconfigurationsAppWebComponent';
import { WEB_COMPONENT_MISCONFIGURATIONS_APP } from '../../webcomponents.constants';

export { MisconfigurationsAppWebComponent };

window.customElements.define(WEB_COMPONENT_MISCONFIGURATIONS_APP, MisconfigurationsAppWebComponent);
